import Big from 'big.js';
import { IPortfolioCompany } from '@portfolio/IPortfolioReducer';
import { EOverviewValueSize } from '@portfolio/components/OverviewBox/IOverviewBox';
import { TAsset } from '@appInterfaces/spv.interfaces';

export const calculateOverviewValues = (
  companies: IPortfolioCompany[]
): { totalPaidOut: Big; amountInvested: Big; profit: Big } =>
  companies.reduce(
    (tally, curr) => {
      if (!curr.equity) return tally;

      tally.totalPaidOut = Big(tally.totalPaidOut).plus(
        curr.equity.total_paid_out
      );
      tally.amountInvested = Big(tally.amountInvested).plus(
        curr.equity.amount_invested
      );
      tally.profit = Big(tally.profit).plus(curr.equity.profit);

      return tally;
    },
    {
      totalPaidOut: Big(0),
      amountInvested: Big(0),
      profit: Big(0),
    }
  );

export const createOverviewData = (
  totalPaidOut: string,
  amountInvested: string,
  profit: string
) => [
  {
    label: 'Profit',
    amount: {
      value: profit,
      size: EOverviewValueSize.large,
    },
    tooltip: 'Lorem ipsum ege siege.',
  },
  {
    label: 'Total amount invested',
    amount: {
      value: amountInvested,
      size: EOverviewValueSize.small,
    },
  },
  {
    label: 'Total paid out',
    amount: {
      value: totalPaidOut,
      size: EOverviewValueSize.small,
    },
  },
];

export const hasActiveAssets = (assets: TAsset[]) =>
  assets.find(asset => asset.amount && Big(asset.amount).gt(0));

